<template>
  <!--
    Kontener główny sekcji filtrowania danych pojazdu:
    - .vehicle-data: dedykowana klasa dla stylów
    - d-flex, flex-wrap, flex-fill: klasy Flexbox do układu
  -->
  <div class="vehicle-data d-flex flex-wrap flex-fill">
    <!-- Nagłówek sekcji: przetłumaczony klucz "vehicle-data", w kapitalikach -->
    <h3>{{ t('vehicle-data').toUpperCase() }}</h3>
    <!-- Przerwa/linia oddzielająca nagłówek od filtrów -->
    <div class="break"></div>

    <!-- Kontener dla dwóch kolumn filtrów pojazdu -->
    <div class="d-flex vehicle-container">
      <!-- Lewa kolumna filtrów pojazdu -->
      <div class="flex-nowrap vehicle-half">
        <!-- Pojedynczy filtr: rejestracja pojazdu -->
        <single-filter
          :name="t('registration')"
          symbol="="
          fieldName="plateLpr"
        />

        <!-- Zakresowy filtr: prędkość [km/h] -->
        <range-filter v-if="!shouldHideLocation"
          :name="t('speed') + ' [km/h]'"
          :symbolFrom="t('from')"
          fieldFromName="minSpeed"
          :symbolTo="t('to')"
          fieldToName="maxSpeed"
        />

        <!-- Zakresowy filtr: masa całkowita [kg] -->
        <range-filter v-if="!shouldHideLocation"
          :name="t('short-total-weight') + ' [kg]'"
          :symbolFrom="t('from')"
          fieldFromName="minTotalLoad"
          :symbolTo="t('to')"
          fieldToName="maxTotalLoad"
        />

        <!-- Zakresowy filtr: długość pojazdu [cm] -->
        <range-filter v-if="!shouldHideLocation"
          :name="t('length') + ' [cm]'"
          :symbolFrom="t('from')"
          fieldFromName="minVehLength"
          :symbolTo="t('to')"
          fieldToName="maxVehLength"
        />

        <!-- Zakresowy filtr: wysokość pojazdu [cm] -->
        <range-filter v-if="!shouldHideLocation"
          :name="t('height') + ' [cm]'"
          :symbolFrom="t('from')"
          fieldFromName="minVehHeight"
          :symbolTo="t('to')"
          fieldToName="maxVehHeight"
        />
      </div>

      <!-- Prawa kolumna filtrów pojazdu -->
      <div class="vehicle-half">
        <!-- Pojedynczy filtr: współczynnik podobieństwa [%] -->
        <single-filter
          :name="t('similarity')"
          symbol=">="
          fieldName="similarity"
        />

        <!-- Zakresowy filtr: liczba osi [szt.] -->
        <range-filter v-if="!shouldHideLocation"
          :name="t('no-of-axles') + ' [szt.]'"
          :symbolFrom="t('from')"
          fieldFromName="minNumberOfAxles"
          :symbolTo="t('to')"
          fieldToName="maxNumberOfAxles"
        />

        <!-- Zakresowy filtr: przeciążenie pojedynczej osi [%] -->
        <range-filter v-if="!shouldHideLocation"
          :name="t('single-axle') + ' [%]'"
          :symbolFrom="t('from')"
          fieldFromName="minOverloadSA"
          :symbolTo="t('to')"
          fieldToName="maxOverloadSA"
        />

        <!-- Zakresowy filtr: przeciążenie wieloosiowe [%] -->
        <range-filter v-if="!shouldHideLocation"
          :name="t('multiple-axle') + ' [%]'"
          :symbolFrom="t('from')"
          fieldFromName="minOverloadMA"
          :symbolTo="t('to')"
          fieldToName="maxOverloadMA"
        />

        <!-- Zakresowy filtr: dopuszczalna masa całkowita [%] -->
        <range-filter v-if="!shouldHideLocation"
          :name="t('dmc') + ' [%]'"
          :symbolFrom="t('from')"
          fieldFromName="minOverloadTL"
          :symbolTo="t('to')"
          fieldToName="maxOverloadTL"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Import Pinia store z aktualnymi filtrami
import { useCurrentFiltersStore } from "../../stores/currentFilters";
// Import komponentów filtrujących typu zakresowego i pojedynczego
import RangeFilter from "./RangeFilter.vue";
import SingleFilter from "./SingleFilter.vue";
import { computed } from "vue";
import { isSG } from "@/config/appVersion";

export default {
  name: "VehicleData",   // Nazwa komponentu
  components: { SingleFilter, RangeFilter }, // Rejestracja używanych komponentów
  setup() {
    // Inicjalizacja instancji store dla filtrów
    const filtersStore = useCurrentFiltersStore();

    const shouldHideLocation = computed(() => isSG);

    // Zwracamy store, aby używać go w template
    return { filtersStore, shouldHideLocation };
  },
  methods: {
    /**
     * Przykładowa metoda dodająca wybrany filtr do store
     * @param {number} index - indeks wybranego elementu (tu nieużywany)
     */
    setFilter(index) {
      this.filtersStore.addItem("VehicleData", index);
    },
  },
};
</script>

<style scoped>
/* Styl nagłówka sekcji */
h3 {
  padding-left: 9px;
}

/* Styl kontenera .vehicle-data */
.vehicle-data {
  width: 350px;
  min-height: 140px;
  margin-bottom: 1rem;
}

/* Styl nagłówka <h3> wewnątrz vehicle-data */
.vehicle-data h3 {
  margin: 0;
  padding: 0.85rem 1rem 0.9rem 1rem;
  border-bottom: 1px solid #bfbfbf;
  width: 100%;
  margin-bottom: 1rem;
}
</style>

<style>
/* Dodatkowe style nie-scope'owane dla komponentu */
.vehicle-data {
  font-size: 12px;
}
.vehicle-data .name {
  font-weight: normal;
  font-size: 12px;
  width: 125px;
  padding: 5px;
  margin: 0;
}
.vehicle-half {
  width: 274px;
  margin: 3px 35px 10px;
}
.vehicle-container {
  width: 100%;
  justify-content: center;
}
</style>
